<div class="header">
  <div class="close-dialog" (click)="closeDialog()"></div>

  <div class="header-content">
    <h4>Hello {{ user.firstName }}!</h4>
    <p *ngIf="!!contact.reservationId" class="location-text">
      We're looking forward to seeing you at
      <span class="location-infos">{{ trainingEvent.trainingLocationDisplayName }} on
        {{ displayTrainingStartDate }}
      </span>
    </p>
    <p class="questions">
      For any question and support, feel free to reach out to us.
    </p>
  </div>
</div>

<div cobaltModalContent class="contact-infos-container">
  <div class="picture-name-availability">
    <div class="picture">
      <img src="{{ contact.profilePicture }}" alt="Profile Picture" />
    </div>

    <div class="contact-infos">
      <div class="contact-name">{{ contact.name }}</div>

      <div class="contact-availability">
        <span>Mon. to Fri. </span>
        <span>{{ contact.availabilityStartTime }} -
          {{ contact.availabilityEndTime }}
        </span>
        <span>&nbsp;(UTC)</span>
      </div>
    </div>
  </div>

  <div class="phone-and-mail-container">
    <div class="info-row">
      <div class="contact-type-icon">
        <cobalt-icon name="phone-outline"></cobalt-icon>
      </div>
      <a cobaltLinkPrimary variant="regular" (click)="logHeap('Web_Phone_Number_Clicked')"
        href="tel:{{ contact.phoneNumber }}">{{ contact.phoneNumber }}</a>
    </div>

    <div class="info-row second-info-row">
      <div class="contact-type-icon">
        <cobalt-icon name="email-outline"></cobalt-icon>
      </div>
      <a cobaltLinkPrimary variant="regular" (click)="logHeap('Web_Email_Clicked')"
        href="mailto:{{ contact.email }}?subject=Training Event Help">{{ contact.email }}</a>
    </div>
  </div>
</div>

<cobalt-divider></cobalt-divider>

<div class="help">
  <p>You can always find this information under the help icon</p>
  <cobalt-icon class="icon help-link" name="help-circle-outline" [size]="cobaltIconSize"
    (click)="showHelp()"></cobalt-icon>
</div>

<cobalt-divider></cobalt-divider>

<div class="moreTrainings">
  <p>
    We noticed that you have more upcoming trainings linked to your account. You
    can find your other contacts on the
    <a class="help-link" cobaltLinkPrimary variant="inline" (click)="showHelp()">Customer Care Page</a>
  </p>
</div>